<template>
  <div>
    <AppHeader />
    <main id="site-content">
      <transition name="page" mode="out-in">
        <slot />
      </transition>
    </main>
    <AppFooter v-if="!isSmallScreen" />
    <TheCompareWidget />
    <TheCompareModal />
  </div>
</template>

<script>
import bus from '@/plugins/bus';
import AppHeader from '@/components/layout/AppHeader.vue';
import AppFooter from '@/components/layout/AppFooter.vue';
import TheCompareModal from '@/components/common/TheCompareModal.vue';
import TheCompareWidget from '@/components/common/TheCompareWidget.vue';

export default {
  name: 'Default',

  components: {
    AppHeader,
    AppFooter,
    TheCompareModal,
    TheCompareWidget,
  },

  data() {
    return {
      expiryTime: 3600, // 1 hour
    };
  },

  computed: {
    isSmallScreen() {
      return this.$store.state.isSmallScreen;
    },
  },

  mounted() {
    this.init();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkWidth);
  },

  methods: {
    init() {
      this.getNewsCategories();
      this.getSpecifications();
      this.resizeListener();
      this.setLocale();
    },

    async getNewsCategories() {
      const { items, timestamp } = this.$store.state.news.categories;
      const now = this.$day().unix();
      const isExpired = (now - timestamp) > this.expiryTime;

      if ((timestamp || items.length) && !isExpired) {
        bus.$emit('category-ready');
        return;
      }

      await this.$store.dispatch('news/getCategories');
      bus.$emit('category-ready');
    },

    async getSpecifications() {
      const { items, timestamp } = this.$store.state.specifications;
      const now = this.$day().unix();
      const isExpired = (now - timestamp) > this.expiryTime;

      if ((timestamp || items.length) && !isExpired) {
        return;
      }

      await this.$store.dispatch('getSpecifications');
    },

    resizeListener() {
      this.$store.dispatch('setSmallScreen');

      window.addEventListener('resize', () => {
        this.$store.dispatch('setSmallScreen');
      }, { passive: true });
    },

    setLocale() {
      const { locale } = this.$store.state;
      this.$i18n.locale = locale;
      this.$day.locale(locale);
    },
  },
};
</script>
